<template>
    <div class="card">
        <div class="card-header grid-x align-middle grid-padding-x">
            <div class="cell shrink">
                <span class="text-site-gray f-15 bold">Filter</span>
            </div>
            <div class="cell shrink">
                <select v-model="filter_status">
                    <option value="show_all">All</option>
                    <option value="show_active">Active</option>
                    <option value="show_inprogress">In Progress</option>
                </select>
            </div>
        </div>
        <div class="card-table grid-x align-middle grid-padding-x">
            <table class="unstriped">
                <thead>
                    <tr>
                        <th>Role</th>
                        <th>Reference</th>
                        <th>Time Left</th>
                        <th>Status</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="baseline in filtered" :key="baseline.id">
                        <td>{{ baseline.company_role.title }}</td>
                        <td>{{ baseline.area }}</td>
                        <td>{{ baseline.time_left || 'Expired' }}</td>
                        <td>{{ baseline.complete ? 'Active' : 'In Progress' }}</td>
                        <td>
                            <button v-on:click="edit(baseline)" data-open="modify-baseline" class="button-dprimary">Modify</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="reveal" id="modify-baseline" data-reveal>
            <h1>Modify Baseline</h1>
            <div v-if="currentEdit !== null">
                <label>Role
                    <input type="text" readonly v-bind:value="currentEdit.company_role.title">
                </label>
                <fieldset>
                    <input id="visibility" type="checkbox" ref="visible_on_search" v-model="currentEdit.visible_on_search"><label for="visibility">Visible On Search List</label>
                </fieldset>
                <label>Reference
                    <input type="text" ref="area" v-model="currentEdit.area">
                </label>

                <button class="button-dprimary" v-on:click="save" ref="save_button">Save</button>
            </div>
        </div>
    </div>
</template>

<script>
import { filter, findIndex } from 'lodash';
import axios from 'axios';

export default {
    name: "baselines-settings",

    props: {
        baselines: {
            required: true,
            default: []
        }
    },

    data: function () {
        return {
            filter_status: "show_active",
            currentEdit: null
        }
    },

    methods: {
        filterStatus: function () {
            if (this.filter_status === 'show_all') return null;

            return ['complete', this.filter_status === 'show_active' ? true : false];
        },

        edit: function (baseline) {
            this.currentEdit = baseline;
        },

        save: async function (evt) {
            if (this.currentEdit === null) return false;

            evt.target.setAttribute('disabled', 'disabled');

            try {
                const xhr = await axios.post(`/recruiter/baselines/modify/${this.currentEdit.id}`, this.currentEdit);
                
                if (!xhr.data.success) {
                    throw new Error();
                }
                
                this.$set(this.baselines, findIndex(this.baselines, ['id', this.currentEdit.id]), this.currentEdit);
                alert('Updated Successfully');
                $('#modify-baseline').foundation('close');
            } catch (e) {
                console.log(e);
                alert('Unable to modify baseline. Please try again');
            }

            evt.target.removeAttribute('disabled');
        }
    },

    computed: {
        filtered: function () {
            return filter(this.baselines, this.filterStatus());
        }
    }
}
</script>